import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Questions from "./Questions";

function QuizPage({ courseId, lectureId, lastTestId, refreshKey, menuReload }) {
  
  const [user] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")) || null; }
    catch { return null; }
  });

  const [isCertified, setIsCertified] = useState(false);
  const [questions, setQuestions] = useState(null);
  const [isHidden, setIsHidden] = useState(true);
  const [isDiabled, setIsDisabled] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [grading, setGrading] = useState(0);
  const [displayGrade, setDisplayGrade] = useState(true);
  const [bestGrade, setBestGrade] = useState(0);
  const navigate = useNavigate();
  const isLastTestID = lastTestId === lectureId ? true : false;
  
  // console.log(isLastTestID, lastTestId, isCertified)

  useEffect(() => {
    if (courseId && lectureId) {
      axios
        .post("/extractQuizCourseContent", { courseId, lectureId })
        .then((data) => {
          let quizArr = Object.keys(data.data);
          let finalQuizes = [];
          let count = 0;

          // DAVIS NOTE: THIS BLOCK RANDOMIZES QUESTIONS FROM THE ARRAY AND 
          // SENDS JUST 5 QUESTIONS BACK... WHY WOULD WE DO THIS?
          while (quizArr.length > 0 && count < 5) {
            let rndInt = Math.floor(Math.random() * quizArr.length) + 1;
            finalQuizes.push(data.data[quizArr[rndInt - 1]]);
            quizArr.splice(rndInt - 1, 1);
            // count = count + 1;
          }
          Promise.all(finalQuizes).then(() => setQuestions(finalQuizes));
        });
    }
  }, [courseId, lectureId]);

  useEffect(() => {
    if (!courseId || !user?.email) return; // guard against missing data
    const controller = new AbortController();

    axios.post(
      "/courseStatus",
      { courseId, userEmail: user.email },
      { signal: controller.signal }
    )
    .then(({ data }) => {
      if (data && typeof data.isCertified === "boolean") {
        setIsCertified(data.isCertified);
      } else {
        setIsCertified(false);
      }
    })
    .catch((err) => {
      console.error("courseStatus error:", err);
      setIsCertified(false);
    });

    return () => controller.abort(); // cleanup on unmount or dependency change
  }, [courseId, user?.email, refreshKey]);


  useEffect(() => {
    // console.log("Grade outer:", grading);
  }, [grading]);

  const computePercentGradeFromDOM = (questionsArr) => {
    if (!Array.isArray(questionsArr) || !questionsArr.length) return 0;

    const isEqualSet = (aArr, bArr) => {
      if (!Array.isArray(aArr) || !Array.isArray(bArr)) return false;
      if (aArr.length !== bArr.length) return false;
      const aSet = new Set(aArr);
      for (const v of bArr) if (!aSet.has(v)) return false;
      return true;
    };

    let correctCount = 0;

    questionsArr.forEach((q, idx) => {
      const correct = q.answer;
      const isMulti = Array.isArray(correct);

      if (isMulti) {
        // If your Questions uses checkboxes with names like options${idx}-${optKey}:
        const checked = Array.from(
          document.querySelectorAll(`input[name^="options${idx}-"]:checked`)
        ).map(el => el.value);
        if (isEqualSet(checked, correct)) correctCount += 1;
      } else {
        const picked = document.querySelector(`input[name="options${idx}"]:checked`);
        if (picked && picked.value === correct) correctCount += 1;
      }
    });

    return (correctCount / questionsArr.length) * 100;
  };

  const changeHiddenDisable = () => {
    setIsDisabled(true);
    setIsHidden(false);
    setButtonDisable(true);
    

    const freshPercent = computePercentGradeFromDOM(questions);
    const outgoingGrade = freshPercent;
    axios
      .post("/returnBestGrade", {
        courseId,
        lectureId,
        userEmail: user.email,
        grade: outgoingGrade,
      })
      .then(({ data }) => {
        setBestGrade(typeof data?.grade === "number" ? data.grade : 0);
        setDisplayGrade(false);
        menuReload(new Date().getTime());
      })
      .catch(err => {
        console.error("returnBestGrade failed", err);
        setButtonDisable(false);
      });
  };

  const goToMyCertificates = () => {
    navigate('/mycertificates');
  };


  return (
    <Container>
      {questions && (
        <div>
          <Questions
            key={"QuestionKey"}
            questions={questions}
            isHidden={isHidden}
            isDiabled={isDiabled}
            buttonDisable={setButtonDisable}
            grade={(val) => setGrading(val)}
          />
          <ButtonContainer>
            {/* NEED TO ADD A CONDITION THAT THIS SHOULD ONLY APPEAR FOR THE LAST QUIZ */}
            {isCertified && isLastTestID && Number(bestGrade.toFixed(1)) >= 80 ? (
              <SubmitQuiz 
                onClick={goToMyCertificates}>
                View Certificate
              </SubmitQuiz>
            ) : (
              <SubmitQuiz
                onClick={changeHiddenDisable}
                disabled={buttonDisable}>
                Submit
              </SubmitQuiz>
            )}
          </ButtonContainer>
          {bestGrade != null && (
            <GradeContainer style={{ display: displayGrade ? "none" : "block" }}>
              Your grade on this attempt is {`${Math.round((computePercentGradeFromDOM(questions) / 100) * questions.length)}/${questions.length} - ${Math.round(computePercentGradeFromDOM(questions))}%`}<br />
              Your best grade is {Number(bestGrade.toFixed(1))} % <br />
              {Number(bestGrade.toFixed(1)) < 80 && (
                <div style={{ color: "crimson", marginTop: 8 }}>
                  You need at least 80% to pass. Please retake this quiz.
                </div>
              )}
            </GradeContainer>
          )}
        </div>
      )}
    </Container>
  );
}

export default QuizPage;

const Container = styled.div``;

const SubmitQuiz = styled.button`
  border: none;
  outline: none;
  border-radius: 4px;
  color: white;
  font-weight: 600;
  padding: 10px;
  background-color: #5fb05f;

  transition: background-color 0.25s ease, transform 0.25s ease;
  &:hover:not(:disabled) {
    background-color: #3e753e;
    transform: scale(1.07);
    cursor: pointer;
  }
  &:disabled {
    background-color: grey;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin: 0 auto;
  justify-content: center;
`;

const GradeContainer = styled.div``;
